import { Expose, Type } from "class-transformer";
import { IsDate, IsDefined, IsNumber, IsString, IsUUID, IsOptional, IsArray } from "class-validator";
import { v4 as uuid } from "uuid";

import { GObjectType, GInputType, GField, GInt } from "../graphql";
import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn, CDIndex } from "../orm";
import { TransformToDate } from "../transformers/transformToDate";

import { CustomerFeedbackStop } from "./CustomerFeedbackStop";

@GObjectType("CustomerFeedback")
@GInputType("CustomerFeedbackInput")
@CDEntity("customerFeedbacks")
export class CustomerFeedback extends CDBaseEntity {
    @GField()
    @CDObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @GField()
    @CDColumn()
    @IsDate()
    @IsDefined()
    @Expose()
    @TransformToDate
    public createdAt: Date = new Date(); // requested at

    @GField()
    @CDColumn()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    @CDIndex()
    public orderId: string;

    @GField()
    @CDColumn()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public driverUserId: string;

    @GField(() => GInt, { nullable: true })
    @CDColumn()
    @IsNumber()
    @Expose()
    public textScore?: number; // management will fill this after reading the customers response (text)
    // 5 = good, 4 = neutral, 3 = bad, 2 = fire, 1 = FIRE

    @GField()
    @CDColumn()
    @IsString()
    @Expose()
    public text: string; // defined when the customer respond

    @GField(() => [CustomerFeedbackStop], { nullable: true })
    @CDColumn()
    @IsArray()
    @IsOptional()
    @Type(() => CustomerFeedbackStop)
    public stops?: CustomerFeedbackStop[];
}
